module.exports = "https://static.zego.com/_next/static/images/hiw-cyber-icon-edcdbc14b3fdc91da0af1a99a5d48a8b.svg";